import type { FC, ReactNode } from 'react'
import type { Variants } from 'motion/react'

import { motion } from 'motion/react'
import { cn } from '@/lib/utils'

const EASE = [0.22, 1, 0.36, 1] as const

const lineVariants: Variants = {
    hidden: {},
    show: { transition: { staggerChildren: 0.09 } }
}

const wordVariants: Variants = {
    hidden: { opacity: 0, y: '0.35em', filter: 'blur(6px)' },
    show: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 1.2, ease: EASE } }
}

interface RevealWordsProps {
    text: string
    id?: string
    className?: string
    as?: 'h1' | 'h2' | 'h3' | 'p'
}

// A headline that reveals itself word by word as it scrolls into view.
const RevealWords: FC<RevealWordsProps> = ({ text, id, className, as = 'h2' }): ReactNode => {
    const Tag = as
    const words = text.split(' ')

    return (
        <Tag id={id} className={cn('font-heading text-cocoa', className)}>
            <span className='sr-only'>{text}</span>

            <motion.span
                aria-hidden='true'
                initial='hidden'
                whileInView='show'
                viewport={{ once: true, amount: 0.6 }}
                variants={lineVariants}
            >
                {words.map((word, index) => (
                    <span key={`${word}-${index}`}>
                        <motion.span variants={wordVariants} className='inline-block'>
                            {word}
                        </motion.span>
                        {index < words.length - 1 ? ' ' : ''}
                    </span>
                ))}
            </motion.span>
        </Tag>
    )
}

export default RevealWords
